module.exports = __webpack_public_path__ + "img/img11.aa414483.jpg";